import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, SharedModule } from 'primeng/api';

import { ToastModule } from 'primeng/toast';
import { LayoutComponent } from '../../components/layout/layout.component';
import { AcademyService } from '../../services/academy/academy.service';
import { LoadingService } from '../../services/loading/loading.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-answer-form',
  imports: [
    LayoutComponent,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './answer-form.component.html',
  styleUrl: './answer-form.component.scss'
})
export class AnswerFormComponent {
  public title: string = '';
  public formId: string = '';
  public form!: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private academyService: AcademyService,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private sessionService: SessionService,
    private messageService: MessageService,
  ) {
    this.form = this.formBuilder.group({
      title: [{ value: '', disabled: true }],
      answers: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.formId = params['id'];
      this.loadForm(this.formId);
    });
  }

  get answers(): FormArray<FormGroup> {
    return this.form.get('answers') as FormArray<FormGroup>;
  }

  getPosiblesArray(answer: FormGroup): FormArray {
    return answer.get('posibles') as FormArray;
  }

  loadForm(formId: string) {
    this.loadingService.show();

    this.academyService.getFormById(formId).subscribe({
      next: (response: any) => {
        this.form.patchValue({
          title: response.title
        });

        this.title = response.title || 'Formulario sin título';

        while (this.answers.length) {
          this.answers.removeAt(0);
        }

        response.answer.forEach((answerItem: any) => {
          const questionGroup = this.formBuilder.group({
            id: answerItem.id,
            question: [{ value: answerItem.question, disabled: true }],
            posibles: this.formBuilder.array(
              answerItem.posibles.map((option: string) =>
                this.formBuilder.control({ value: option, disabled: true })
              )
            ),
            selectedIndex: [null]
          });

          this.answers.push(questionGroup);
        });

        this.loadingService.hide();
      },
      error: (error) => {
        console.error('Error al obtener el formulario:', error);
        this.loadingService.hide();
      }
    });
  }

  submitForm() {
    const session = this.sessionService.getSession();
    const raw = this.form.getRawValue();

    const payload = {
      answer: this.formId,
      employee: session.employee.id,
      response: raw.answers.map((answer: any) => ({
        id_answare: answer.id,
        response: answer.selectedIndex
      }))
    };

    const allResponsesFilled = payload.response.every((item: any) => item.response != null);

    if (!allResponsesFilled) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor, completa todas las preguntas antes de enviar el formulario.'
      });

      return;
    }

    this.loadingService.show();

    this.academyService.submitFormAnswers(payload).subscribe({
      next: (response: any) => {
        this.loadingService.hide();
        this.router.navigate(['/']);
      },
      error: (error: any) => {
        console.error('Error al enviar las respuestas:', error);
        this.loadingService.hide();
      },
      complete: () => {
        console.log('Respuestas enviadas con éxito');
      }
    });
  }

  cancel() {
    this.router.navigate(['/']);
  }
}
